import ReactDOM from 'react-dom';

const PromoPopupPortal = ({ children }) => {
    if (__isBrowser__) {
        return ReactDOM.createPortal(children, document.body);
    }
    return null;
};
export default PromoPopupPortal;
